import { useNavigate } from 'react-router-dom'

import { LayoutPage } from '../LayoutPage'

import './index.css'

// no captured production build ever included a real logo image (same
// reconstruction gap as icons.css — see RECONSTRUCTION_NOTES.md), so this
// mirrors the text wordmark the design mockup settled on instead: "FYC" +
// checkmark + "DEALS" in the sampled brand green, not an invented image asset
const CheckIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="4 13 9 18 20 6"></polyline>
    </svg>
)

const ManageIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="8" y1="6" x2="21" y2="6"></line>
        <line x1="8" y1="12" x2="21" y2="12"></line>
        <line x1="8" y1="18" x2="21" y2="18"></line>
        <line x1="3" y1="6" x2="3.01" y2="6"></line>
        <line x1="3" y1="12" x2="3.01" y2="12"></line>
        <line x1="3" y1="18" x2="3.01" y2="18"></line>
    </svg>
)

const CreateIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
)

const NavigationBarComponent = () => {
    const navigate = useNavigate()

    const handleClickManageDeals = () => {
        navigate('/')
    }

    const handleClickCreateDeals = () => {
        navigate('/create-deals')
    }

    const handleClickLogout = () => {
        navigate('/logout')
    }

    return (
        <div className="c-NavigationBar">
            <LayoutPage>
                <div className="navigationBar-brand" onClick={handleClickManageDeals}>
                    <span className="navigationBar-brandMark">FYC<CheckIcon /></span>
                    <span className="navigationBar-brandWord">Deals</span>
                </div>

                <ul className="navigationBar-navMain">
                    <li onClick={handleClickManageDeals}><ManageIcon />Manage</li>
                    <li onClick={handleClickCreateDeals}><CreateIcon />Create</li>
                    {/* <li>Manage Affiliates</li> */}
                </ul>

                <ul className="navigationBar-navUser">
                    <li onClick={handleClickLogout}>Logout</li>
                </ul>
            </LayoutPage>
        </div>
    )
}

export { NavigationBarComponent }